import * as React from "react";
export var Context = React.createContext(function () { return null; });



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-analytics/dist-es/context.js
// module id = 6lmz
// module chunks = 2